import React, { forwardRef } from 'react';
import {
  AlertTitleProps as MuiAlertTitleProps,
  useThemeProps,
  AlertTitle as MuiAlertTitle,
} from '@mui/material';
import { useLegacyWsdStyles } from 'src/wsd/styles/context/useLegacyWsdStyles';
import type { SystemProps } from '@mui/system';
import { WsdAlertTitleRoot } from 'src/wsd/components/WsdAlert/WsdAlertTitleRoot';

// Re-exported to prevent the addition of system props, which in general have been deprecated.
// See: https://mui.com/material-ui/migration/migrating-from-deprecated-apis/#system-props
export type AlertTitleProps = Omit<
  Omit<MuiAlertTitleProps, keyof SystemProps>,
  | 'align'
  | 'gutterBottom'
  | 'noWrap'
  | 'paragraph'
  | 'variant'
  | 'variantMapping'
>;

export const AlertTitle = forwardRef<HTMLDivElement, AlertTitleProps>(
  function AlertTitle(inProps, ref) {
    const props = useThemeProps({ props: inProps, name: 'MuiAlertTitle' });
    const isWsdAlert = useLegacyWsdStyles();

    return isWsdAlert ? (
      <WsdAlertTitleRoot ref={ref} {...props} />
    ) : (
      <MuiAlertTitle ref={ref} {...props} />
    );
  }
);

// Re-exported to prevent the addition of system props, which in general have been deprecated.
// See: https://mui.com/material-ui/migration/migrating-from-deprecated-apis/#system-props
export default AlertTitle;
